import React from "react";
import cn from "classnames";
import styles from "./TextInputQuantity.module.sass";
import Icon from "../Icon";
import Tooltip from "../Tooltip";
import './TextInputQuantity.css';

const TextInputQuantity = ({
  className,
  classLabel,
  classInput,
  label,
  icon,
  copy,
  currency,
  tooltip,
  place,
  onKeyUp,
  warningIcon,
  checkIcon,
  id,
  warningIconId,
  inputIconId,
  validateSuccessIcon,
  phoneNumInitials,
  value,
  ...props
}) => {

  return (
    <div
      className={cn(
        styles.field,
        { [styles.fieldIcon]: icon },
        { [styles.fieldCopy]: copy },
        { [styles.fieldCurrency]: currency },
        className
      )}
    >
      {label && (
        <div className={cn(classLabel, styles.label)}>
          {label}{" "}
          {tooltip && (
            <Tooltip
              className={styles.tooltip}
              title={tooltip}
              icon="info"
              place={place ? place : "right"}
            />
          )}
        </div>
      )}
      <div className={styles.wrap}>
        <input
          style={{
            paddingLeft: phoneNumInitials ? "45px" : "12px"
          }}
          value={value}
          // defaultValue={value}
          id={id}
          onKeyUp={(e) => {
            // document.getElementById(id).innerHTML = e.target.value
          }}
          className={cn(classInput, styles.input)} {...props}
        />
      </div>
    </div>
  );
};

export default TextInputQuantity;
